import {ThemeColorPath} from 'platform/foundation';
import {match} from 'ts-pattern';

export const getMappedIconColor = (color: string | undefined) =>
  match<string | undefined, ThemeColorPath | null>(color)
    .with('neutral', () => 'text.secondary')
    .with('black', () => 'general.black')
    .with('white', () => 'text.white')
    .with('blue', () => 'palettes.blue.70.100')
    .with('red', () => 'palettes.red.70.100')
    .with('magenta', () => 'palettes.magenta.70.100')
    .with('purple', () => 'palettes.purple.70.100')
    .with('teal', () => 'palettes.teal.70.100')
    .with('green', () => 'palettes.green.70.100')
    .with('yellow', () => 'palettes.yellow.70.100')
    .with('orange', () => 'palettes.orange.70.100')
    .otherwise(() => null);
